export const DEFAULT_BORDER_THICKNESS = 2;
export const LOCKED_BORDER_THICKNESS = 1;
export const ANCHOR_HOVER_RADIUS = 10;

/**
 * Width of the right sidebar panel when open
 * This matches the SIDEBAR_WIDTH constant in canvas-safe-zone.tsx
 */
export const SIDEBAR_WIDTH = 416;

/**
 * Constants for the drawer width
 */
export const DRAWER_WIDTH_STORAGE_KEY = 'canvas-drawer-width-px';
export const DEFAULT_DRAWER_WIDTH = 500;
export const MIN_DRAWER_WIDTH = 400;
export const MAX_DRAWER_WIDTH = 800;
export const DRAWER_PADDING = 16;
